export default __webpack_public_path__ + "static/media/SourceIssue4.b6de7dbe.pdf";